module.exports = __webpack_public_path__ + "img/kjyltitle.cf70e446.png";